/* eslint-disable max-lines */
import { css } from 'linaria';

export const cabinetSignSection = css`
  padding: 80px 0 40px 0;
  background-color: var(--control-primary);

  @media (--only-tablet) {
    padding: 64px 0 44px 0;
  }

  @media (--only-mobile) {
    padding: 40px 0;
    border-radius: 12px 12px 0 0;
  }
`;

export const cabinetSignSectionContainer = css`
  display: flex;
  column-gap: 24px;

  @media (--to-desktop) {
    flex-direction: column;
    column-gap: 0;
  }
`;

export const cabinetSignSectionAddContentContainer = css`
  margin-top: 40px;
  width: 100%;

  @media (--only-desktop) {
    margin-top: 32px;
  }

  @media (--to-desktop) {
    margin-top: 64px;
  }

  @media (--only-mobile) {
    margin-top: 24px;
  }
`;

export const cabinetSignSectionBlockWrapper = css`
  width: 578px;

  @media (--only-desktop) {
    width: 458px;
  }

  @media (--to-desktop) {
    width: 100%;
  }
`;

export const cabinetSignSectionTitle = css`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  margin-bottom: 48px;

  @media (--only-tablet) {
    margin-bottom: 32px;
  }

  @media (--only-mobile) {
    margin-bottom: 24px;
  }
`;

export const cabinetSignSectionPointsColumnWrapper = css`
  display: flex;
  flex-direction: column;
  row-gap: 30px;

  @media (--to-desktop) {
    display: none;
  }
`;

export const cabinetSignSectionColumnPoint = css`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 12px;
  padding: 10px;
  width: 287px;
  background-color: rgb(255 255 255 / 10%);
  border-radius: var(--rounding-m);

  @media (--only-desktop) {
    width: 247px;
  }
`;

export const cabinetSignSectionPointsWrapper = css`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 32px;
  margin-top: 16px;
  background-color: rgb(255 255 255 / 10%);
  border-radius: var(--rounding-m);

  @media (--from-desktop) {
    display: none;
  }

  @media (--only-desktop) {
    padding: 0 20px;
  }

  @media (--only-mobile) {
    justify-content: center;
    padding: 0 12px;
    margin-top: 8px;
    column-gap: 21px;
  }
`;

export const cabinetSignSectionPointsOnlineWrapper = css`
  padding: 0 60px;

  @media (--only-desktop) {
    padding: 0 36px;
  }

  @media (--only-tablet) {
    padding: 0 76px;
  }

  @media (--only-mobile) {
    padding: 0 16px;
  }
`;

export const cabinetSignSectionPoint = css`
  display: flex;
  align-items: center;
  padding: 6px 8px;
  column-gap: 12px;

  @media (--only-desktop) {
    && p {
      font-size: 16px;
      line-height: 24px;
    }
  }

  @media (--only-mobile) {
    padding: 10px 0;
    column-gap: 4px;

    && > div:first-child {
      width: 16px;
      height: 16px;
    }

    && p {
      font-size: 12px;
      line-height: 16px;
    }
  }
`;

export const cabinetSignSectionOnlineImage = css`
  display: block;
  width: 578px;
  height: 302px;
  object-fit: contain;

  @media (--only-desktop) {
    width: 458px;
    height: 236px;
  }

  @media (--only-tablet) {
    width: 660px;
    height: 303px;
  }

  @media (--only-mobile) {
    width: 100%;
    height: 51.5vw;
  }
`;
